import moment from 'moment'
import Vue from 'vue'
import { PROMO_TYPES } from '@/utils/constants/promo-types'
import pagingMap from '@/helpers/pagination'

export const promotion = {
    state: {
        status: 'idle',
        promotion: null,
        promoProductsPagination: {},
        promoProducts: null,
        promoProductSets: null,
        retailersCompanies: null,
        promoAttachmentsStatus: {
            status: 'idle',
            promoId: null
        },
        productsPerPage: 10,
        wholesalePriceMarginTooltips: {
            ECD: 'Marża obliczona na podstawie maksymalnej ceny detalicznej,<br/>maksymalnej ceny hurtowej we wskazanym okresie zatowarowania i zwrotu promocji',
            ECC: 'Marża obliczona na podstawie maksymalnej ceny detalicznej,<br/>maksymalnej ceny hurtowej Eurocash Cash & Carry we wskazanym okresie zatowarowania i zwrotu promocji',
            DZ: 'Marża obliczona na podstawie maksymalnej ceny detalicznej,<br/>maksymalnej ceny hurtowej z dystrybucji zewnętrznej we wskazanym okresie zatowarowania i zwrotu promocji',
            all: 'Marża obliczona na podstawie max. ceny det.,<br/>max. ceny hurt., max. ceny hurt. w ECC, max. ceny hurt. DZ<br/>we wskazanym okresie zatowarowania i zwrotu z promocji.<br/>Więcej informacji znajduje się w szczegółach promocji.'
        }
    },
    mutations: {
        SET_PROMOTION(state, promotion) {
            state.promotion = promotion
        },
        SET_PROMOTION_STATUS(state, payload) {
            state.status = payload
        },
        SET_PROMO_PRODUCTS_PAGINATION(state, payload) {
            state.promoProductsPagination = payload
        },
        SET_PROMO_PRODUCT_SETS(state, payload) {
            state.promoProductSets = payload
        },
        SET_PROMO_PRODUCTS(state, payload) {
            state.promoProducts = payload
        },
        CLEAR_PROMO_PRODUCTS(state) {
            state.promoProductsPagination = {}
            state.promoProducts = null
            state.promoProductSets = null
        },
        SET_RETAILERS_COMPANIES(state, payload) {
            state.retailersCompanies = payload
        },
        SET_PROMO_ATTACHMENTS_STATUS(state, payload) {
            state.promoAttachmentsStatus = payload
        },
        SET_PROMO_PRODUCTS_PER_PAGE(state, payload) {
            state.productsPerPage = payload
        }
    },
    actions: {
        // eslint-disable-next-line no-empty-pattern
        async fetchPromotionAttachments(
            { dispatch },
            { id, name, merchantNetworkId }
        ) {
            const merchantNetworkIds = merchantNetworkId
                ? 'nil,' + merchantNetworkId.toString()
                : null
            const response = await this.$api.get(`promos/${id}/attachments`, {
                responseType: 'arraybuffer',
                params: {
                    merchant_network_id: merchantNetworkIds
                }
            })
            const blob = new Blob([response.data], {
                type: `data:${response.headers['content-type']};base64`
            })
            const fileType = response.headers['content-type'].split('/').pop()

            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${name}.${fileType}`

            // Firefox requires the link to be in the body
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        async fetchPromoGroup({ state, commit }, params) {
            commit('SET_PROMOGROUPS_STATUS', 'idle')
            try {
                const res = await this.$api.get('promo_groups', {
                    params
                })
                commit('SET_PROMOGROUPS', [
                    {
                        ...res.data.data[0],
                        promos: [
                            {
                                ...state.promotion,
                                main_set: true,
                                groupId: res.data.data[0].id,
                                subscriptionsEqualPrices: {
                                    equalPrices: false,
                                    priceGroups: [state.promotion.subscriptions]
                                }
                            }
                        ],
                        selectWholeGroup: false,
                        status: 'idle'
                    }
                ])
                return res.data.data
            } catch (err) {
                console.log(err)
            }
            commit('SET_PROMOGROUPS_STATUS', 'loading')
        },
        async fetchPromoGroupPagination(
            { state, commit, getters, dispatch },
            payload
        ) {
            commit('SET_PROMOGROUPS_STATUS', 'idle')
            const { paramsPromos } = await dispatch('setPromoFilterQueryParams')
            try {
                const res = await this.$api.get('promos', {
                    params: {
                        promo_group_id: payload,
                        ...paramsPromos
                    }
                })
                const pagination = res.data.pagination[0]
                for (const [key, value] of Object.entries(pagination)) {
                    pagination[key] = +value
                }
                commit('SET_PROMOGROUPS', [
                    {
                        ...getters.getPromoGroups[0],
                        pagination
                    }
                ])
            } catch (err) {
                console.log(err)
            }
            commit('SET_PROMOGROUPS_STATUS', 'loading')
        },
        async promotionFetch({ commit, getters }, payload) {
            const { promoId, ...params } = payload

            try {
                const { status, data } = await this.$api.get(`promos/${promoId}`, {
                    params: {
                        ...params,
                        'subscription|merchant_id': getters.getMerchants
                            .map(el => el.id)
                            .join(',')
                    }
                })

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Error GET promo')
                }

                const promotion = {
                    ...data.data,
                    usage_limit_per_receipt: Number(
                        data.data.usage_limit_per_receipt
                    ),
                    products: [],
                    product_sets: [],
                    selected: false,
                    accepted: false
                }
                commit('SET_PROMOTION', promotion)
                return data.data
            } catch (error) {
                throw Error(error)
            }
        },
        async loadPromotion({ state, commit, dispatch, getters }, payload) {
            commit('SET_PROMOTION', null)
            commit('SET_PROMOTION_STATUS', 'loading')

            try {
                // await dispatch('promotionFetch', {
                //     ...payload,
                //     includes: 'infographic,company,logo,company.logo,terms'
                // })
                // await dispatch('loadPromoProducts', {
                //     per: 1,
                //     totalProductsRecords: true,
                //     main: true
                // })
                // await dispatch('fetchPromoGroup', {
                //     'promo|id': payload.promoId
                // })

                // All next actions can be do at once
                // const promises = [
                //     dispatch('loadPromoSalesTargetThresholds', payload),
                //     dispatch('loadPromoProducts', {
                //         per: state.productsPerPage,
                //         main: true,
                //         includes: 'dict_product,dict_product.image'
                //     }),
                //     dispatch('loadPromoSubscriptions'),
                //     dispatch('loadSaleTargetMerchantUsages', payload),
                //     dispatch('loadPromoGroup', state.promotion.id),
                //     dispatch(
                //         'fetchPromoGroupPagination',
                //         state.promotion.promo_group_id
                //     )
                // ]
                // await Promise.all(promises)

                // await dispatch('fetchPromoAttachments', {
                //     promo_id: state.promotion.id,
                //     merchant_network_id: [
                //         ...new Set(
                //             state.promotion.subscriptions.map(
                //                 e => e.merchant_network_id
                //             )
                //         )
                //     ]
                // })
                // await dispatch('selectAllSubsToStop', true)

                await dispatch('promotionFetch', {
                    ...payload,
                    includes: 'infographic,company,logo,company.logo,terms'
                })
                await dispatch('loadPromoProducts', {
                    per: 1,
                    totalProductsRecords: true,
                    main: true
                })
                await dispatch('loadPromoSalesTargetThresholds', payload)
                await dispatch('loadPromoProducts', {
                    per: 1,
                    totalProductsRecords: true,
                    main: true
                })
                await dispatch('loadPromoProducts', {
                    per: state.productsPerPage,
                    main: true,
                    includes: 'dict_product,dict_product.image'
                })
                await dispatch('loadPromoSubscriptions')
                await dispatch('selectAllSubsToStop', true)
                await dispatch('loadSaleTargetMerchantUsages', payload)

                const merchantIds = state.promotion.subscriptions.map(e => e.merchant_id)
                const uniqueMerchantNetworkIds = [
                    ...new Set(
                        merchantIds.map(id => getters.getNetworkByMerchantId(id)?.id)
                    )
                ]

                await dispatch('fetchPromoAttachments', {
                    promo_id: state.promotion.id,
                    merchant_network_id: uniqueMerchantNetworkIds
                })
                await dispatch('loadPromoGroup', state.promotion.id)
                await dispatch(
                    'fetchPromoGroupPagination',
                    state.promotion.promo_group_id
                )
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_PROMOTION_STATUS', 'idle')
            }
        },
        async loadPromoGroup({ state, commit, dispatch }, promoId) {
            try {
                const promoGroup = await dispatch('fetchPromoGroup', {
                    'promo|id': promoId
                })
                commit('SET_PROMOTION', {
                    ...state.promotion,
                    groupId: promoGroup[0].id
                })
            } catch (err) {
                console.log(err)
            }
        },
        async promoProductSetsFetch({ commit }, params) {
            try {
                const res = await this.$api.get('product_sets', {
                    params
                })

                if (res.status !== 200 || !res.data?.data) {
                    throw new Error(
                        res.data?.message || 'Error GET product_sets'
                    )
                }

                return res
            } catch (err) {
                throw Error(err)
            }
        },
        async loadPromoProducts({ state, commit, dispatch, getters }, payload = {}) {
            const params = {
                ...payload.params,
                per: payload.per || state.promoProductsPagination.perPage,
                page: payload.page || state.promoProductsPagination.page,
                promo_id: state.promotion.id,
                promo_dict_product_id: payload.promoDictProductId,
                main: payload.main === undefined ? true : payload.main,
                includes: payload.includes
            }

            try {
                if (getters.hasProductSets(state.promotion.type)) {
                    let promoSets = getters.getPromoProductSets

                    // If no sets in store, fetch them
                    if (!promoSets.length) {
                        const productsSetData = await dispatch(
                            'promoProductSetsFetch',
                            params
                        )
                        promoSets = productsSetData.data.data
                    }

                    // If no sets in payload, use promoSets
                    const setsIdToUpdate = (payload.productSets || promoSets).map(set => set.id)

                    // Fetch products by product set
                    for (const set of promoSets) {
                        if (setsIdToUpdate.includes(set.id) === false) {
                            // Update only sets that are in payload.productSets
                            // or all promo sets if payload.productSets is not provided
                            continue
                        }

                        const { data } = await dispatch('fetchProducts', {
                            params: {
                                ...params,
                                product_set_id: set.id
                            },
                            config: {
                                noCancel: true
                            }
                        })

                        const pagination = pagingMap(data.pagination)

                        const products = data.data.map(p => ({ ...p, downloadLabel: true }))

                        if (params.main) {
                            set.product_set_dict_products = products
                            set.pagination = pagination
                        } else {
                            set.product_set_dict_products.push(...products)
                        }
                    }

                    if (payload.totalProductsRecords) {
                        commit('SET_PROMOTION', {
                            ...state.promotion,
                            totalProductsRecords: promoSets[0].pagination.totalRecords
                        })
                        return
                    }

                    const setsCopy = JSON.parse(
                        JSON.stringify(promoSets)
                    )
                    commit('SET_PROMO_PRODUCT_SETS', setsCopy)
                } else {
                    const { data } = await dispatch('fetchProducts', { params })

                    const pagination = pagingMap(data.pagination)

                    if (payload.totalProductsRecords) {
                        // If totalProductsRecords is true, update the promotion with total records
                        // and don't update products
                        commit('SET_PROMOTION', {
                            ...state.promotion,
                            totalProductsRecords: pagination.totalRecords
                        })
                        return
                    }

                    // Update products with downloadLabel
                    const products = data.data.map(p => ({ ...p, downloadLabel: true }))

                    if (params.main) {
                        commit('SET_PROMO_PRODUCTS_PAGINATION', pagination)
                        commit('SET_PROMO_PRODUCTS', products)
                    }

                    if (!params.main && payload.promoDictProductId) {
                        commit('SET_PROMO_PRODUCTS', [
                            ...state.promoProducts,
                            ...products
                        ])
                    }
                }
            } catch (err) {
                throw Error(err)
            }
        },
        async loadPromoSubscriptions({ state, commit, dispatch, getters }, params = {}) {
            try {
                const { data } = await dispatch('fetchSubscriptions', {
                    params: {
                        ...params,
                        per: 99999,
                        'promo|id': state.promotion.id
                    }
                })

                let subState = ''
                if (state.promotion.state === 'cancelled') {
                    // if the promotion is cancelled, set state to 'deleted'
                    subState = 'deleted'
                } else if (state.promotion.state === 'finished') {
                    // if the promotion is finished, set state to 'archived'
                    subState = 'archived'
                }

                const subscriptions = data.data || [].map(el => {
                    const merchant = getters.getMerchantById(el.merchant_id)

                    return {
                        ...el,
                        state: subState || el.state,
                        merchant_network_id: merchant.network_id
                    }
                })
                commit('SET_SUBSCRIPTIONS', subscriptions)
                commit('SET_PROMOTION', { ...state.promotion, subscriptions })
            } catch (err) {
                throw Error(err)
            }
        },
        clearPromoProducts({ commit }) {
            commit('CLEAR_PROMO_PRODUCTS')
        },
        async cancelPromotion({ dispatch }, payload) {
            try {
                const res = await this.$api.post('cancellations', {
                    type: 'Cancellation::Promo::DefinitionError',
                    promo_id: payload.promoId,
                    send_notification: false
                })
                if (res && res.status === 200 && res.data.data !== 'error') {
                    dispatch('addNotification', {
                        type: 'success',
                        content: 'Promocja została usunięta'
                    })
                } else {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                }
                return res
            } catch {
                dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd. Spróbuj ponownie później.'
                })
            }
        },
        async fetchRetailersCompanies({ commit }) {
            try {
                const res = await this.$api.get('retailers/companies')
                if (res && res.data.data) {
                    commit('SET_RETAILERS_COMPANIES', res.data.data)
                }
            } catch (err) {
                console.log(err)
            }
        },
        setPromoAttachmentsStatus({ commit }, payload) {
            commit('SET_PROMO_ATTACHMENTS_STATUS', payload)
        },
        async fetchPromoAttachments({ commit, state }, { merchant_network_id, promo_id }) {
            const merchantNetworkIds = merchant_network_id
                ? 'nil,' + merchant_network_id.toString()
                : null

            try {
                const res = await this.$api.get('promo_attachments', {
                    params: {
                        promo_id,
                        merchant_network_id: merchantNetworkIds,
                        includes: 'attachment'
                    }
                })
                if (res && res.data.data) {
                    commit('SET_PROMOTION', {
                        ...state.promotion,
                        attachments: res.data.data.map(el => el.attachment),
                        attachment: res.data.data[0]?.attachment
                    })
                }
            } catch (err) {
                throw Error(err)
            }
        },
        async fetchSalesTargetThresholds(_, payload) {
            try {
                const { data, status } = await this.$api.get(
                    '/sales_target_thresholds',
                    {
                        params: {
                            promo_id: payload.promoId,
                            per: payload.per
                        },
                        config: {
                            noCancel: true
                        }
                    }
                )

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error GET sales_target_thresholds')
                }
                // return data sorted by target value
                return data.data.sort((a, b) => a.target - b.target)
            } catch (error) {
                console.error(error)
            }
        },
        async fetchSaleTargetMerchantUsages({ state }, payload) {
            try {
                const { data, status } = await this.$api.get(
                    'reports/achievement_of_sale_goals',
                    {
                        params: {
                            'promo|id': payload.promoId,
                            'subscription|merchant_id': state.promotion.subscriptions.map(v => v.merchant_id).join(','),
                            includes: 'merchant_usages'
                        }
                    }
                )

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error GET reports/achievement_of_sale_goals')
                }

                return data.data
            } catch (error) {
                console.error(error)
            }
        },
        async loadPromoSalesTargetThresholds({ state, commit, dispatch }, payload) {
            // Fetch only for SALES_TARGET promotion
            if (state.promotion.type !== PROMO_TYPES.SALES_TARGET) return

            const salesTargetThresholds = await dispatch('fetchSalesTargetThresholds', payload)

            if (!salesTargetThresholds) return

            commit('SET_PROMOTION', {
                ...state.promotion,
                salesTargetThresholds: salesTargetThresholds.slice(0, 5)
            })
        },
        async loadSaleTargetMerchantUsages({ state, commit, dispatch }, payload) {
            // Fetch only for SALES_TARGET promotion
            if (state.promotion.type !== PROMO_TYPES.SALES_TARGET) return

            const salesTargetMerchantUsages = await dispatch('fetchSaleTargetMerchantUsages', payload)

            if (!salesTargetMerchantUsages?.length) return

            commit('SET_PROMOTION', {
                ...state.promotion,
                subscriptions: state.promotion.subscriptions.map(sub => {
                    const searchedMerchant = salesTargetMerchantUsages[0].merchant_usages.find(usage =>
                        usage.merchant_id === sub.merchant_id
                    )
                    return {
                        ...sub,
                        salesTargetUsagesAmount: searchedMerchant?.amount
                    }
                })
            })
        }
    },
    getters: {
        getPromotion: state => {
            if (state.promotion) {
                return state.promotion
            }
        },
        getPromoProducts: state => state.promoProducts || [],
        getPromoProductSets: state => state.promoProductSets || [],
        getPromotionStatus: state => {
            if (state.status) {
                return state.status
            }
        },
        getPromotionEans: state => {
            let productEans = []
            if (state.promotion.products?.length) {
                productEans = state.promotion.products.map(el => el.ean)
            }
            if (state.promotion.product_sets?.length) {
                state.promotion.product_sets.map(el => {
                    return el.product_set_dict_products.map(elem => {
                        productEans.push(elem.ean)
                    })
                })
            }
            return productEans
        },
        getPromoProductsPagination: state => state.promoProductsPagination,
        getDaysLeft: state => promotion => {
            const context = new Vue()
            const today = moment(new Date())
            const start = moment(promotion.start_at)
            const end = moment(promotion.end_at)
            if (today < start) {
                const left = start.diff(today, 'days') + 1
                const diff = context.$options.filters.plurals(
                    left,
                    'dzień',
                    'dni'
                )
                return {
                    diff,
                    promotionIncoming: true,
                    countText: 'Do rozpoczęcia promocji',
                    left
                }
            } else {
                const left =
                    end.diff(today, 'days') >= 0
                        ? end.diff(today, 'days') + 1
                        : 0
                let diff = context.$options.filters.plurals(
                    left,
                    'dzień',
                    'dni'
                )
                if (promotion.state === 'cancelled') diff = 'Anulowana'
                if (promotion.state === 'finished') diff = 'Zakończona'
                return {
                    diff,
                    promotionIncoming: false,
                    countText: 'Do końca promocji',
                    left
                }
            }
        },
        getRetailersCompanies: state => state.retailersCompanies,
        getPromoAttachmentsStatus: state => state.promoAttachmentsStatus,
        getPromoProductsPerPage: state => state.productsPerPage,
        getWholesalePriceMarginTooltip: state => (WholesalePriceCode) => {
            return state.wholesalePriceMarginTooltips[WholesalePriceCode] || ''
        }
    }
}
